var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormularioBase',{attrs:{"tiposPermitidos":['ORCAMENTO'],"sistema":"FORCA_VENDAS","moduloKey":"ADMIN_FORMULARIOS_PESQUISA","tabTitulo":"Formulários de Pesquisa","context":"PESQUISA"}})
}
var staticRenderFns = []

export { render, staticRenderFns }